import axios from "../axiosClient";

export const getFaults = async (
  PageNumber: any,
  pageSize: any,
  tcCode: any,
  siteCode: any,
  blockCode: any,
  startDate: any,
  isAcknowledged: any,
  SortBy: any,
  SortDirection: any,
  faultType: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Fault/getFaults`, {
    params: {
      PageNumber,
      pageSize,
      tcCode,
      siteCode,
      blockCode,
      isAcknowledged,
      SortBy,
      SortDirection,
      faultType,
      startDate,
    },
    signal,
  });

  return res?.data;
};
